import styled from 'styled-components';

import colors from '../../styles/colors';

export const StyledTable = styled.table`
  min-width: 100%;
  text-align: left;
  border-collapse: collapse;

  & {
    th {
      padding: 5px 5px 5px 0;
      color: ${colors.darkgray};
      border-bottom: solid 2px ${colors.darkgray};
    }
    th > span {
      cursor: pointer;
      display: flex;
      align-items: center;
    }

    td {
      padding: 16px;
      padding-left: 0;
      color: ${colors.lightblack};
      border-bottom: solid 2px ${colors.lightgray};
      word-break: break-all;
    }

    tr:last-child td {
      border-bottom: solid 2px ${colors.darkgray};
    }

    tr th:first-child,
    tr td:first-child {
      padding-left: 5px;
    }

    tr th:last-child,
    tr td:last-child {
      padding-right: 10px;
    }

    input {
      width: 80%;
      border-radius: 5px;
      border: 1px solid ${colors.gray};
      background: transparent;
      height: 25px;
      padding: 0 2px;
      transition: border 0.3s;
      &::placeholder {
        color: ${colors.gray};
      }
      &:focus {
        border: solid 1px ${colors.darkgray};
      }
  }
`;
